import { Homepage } from "@web-applications/allinga-web-components";
import { useOIDCLogin } from "shared/hooks/useOIDCLogin";
import AllingaVoice from "assets/images/AllingaVoice.svg";
import { PATHS } from "shared/constants";

export default function VQEHomepage() {
  const { auth } = useOIDCLogin();

  const handleLogin = () => {
    auth.signinRedirect();
  };

  return (
    <Homepage
      componentImage={AllingaVoice}
      handleLogin={handleLogin}
      copyrightUrl={PATHS.copyright}
      thirdPartyNoticesUrl={PATHS.thirdPartyNotices}
      shouldUseDefault
    />
  );
}
